import { REPRICE_PROGRESS_CLEAR, REPRICE_PROGRESS_PUSH, REPRICE_PROGRESS_START } from '@/constants/orderConstants'
import { applyRepricePush, dismissRepriceProgress, startRepriceProgress } from '@/utilities/repriceProgress'

// Progress of the background reprice for the open quote (null when nothing to show).
export const repriceProgressReducer = (state = null, action) => {
  switch (action.type) {
    case REPRICE_PROGRESS_START:
      return startRepriceProgress(action.payload.quote_no, action.payload.reason)
    case REPRICE_PROGRESS_PUSH:
      return applyRepricePush(state, action.payload)
    case REPRICE_PROGRESS_CLEAR:
      // Closed by the user: hidden, but kept so a late batch push can't bring it back.
      return dismissRepriceProgress(state)
    default:
      return state
  }
}
